<template>
  <div class="m_container">
    <div class="m_tree_list"><EnumTree :parentMsg="parentMsg" @treeInfo="TreeNodeClick"></EnumTree>
    </div>
    <div class="m_list">
      <el-button type="primary" icon="el-icon-plus" class="m_add_button" size="small" @click="AddPeople" plain>新增人员</el-button>
      <el-button type="primary" class="m_add_button" size="small" plain>角色分配</el-button>
      <el-button type="primary" class="m_query" size="small" plain>查询</el-button>
      <el-input placeholder="请输入姓名/账号查询" prefix-icon="el-icon-search" class="m_query" v-model="QueryData" size="small" style="width:200px"></el-input>
    
      <el-table
    :data="tableData"
    style="width: 100%"
    height=610
    >
    <el-table-column width="30" type="selection"></el-table-column>
    <el-table-column
      label="账号"
      width="180">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.userName }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="姓名"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>
    <el-table-column
      label="联系电话"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.phone }}
      </template>
    </el-table-column>
    <el-table-column
      label="邮箱"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.eMail }}
      </template>
    </el-table-column>
    <el-table-column
      label="QQ号"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.qq }}
      </template>
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button type="primary" icon="el-icon-edit" circle size="small" plain title="编辑"></el-button>
        <el-button type="danger" icon="el-icon-key" circle size="small" plain title="重置密码"></el-button>
        <el-switch v-model="scope.row.status" title="停用/启用"></el-switch>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      @current-change="handleCurrentChange"
      hide-on-single-page="false"
      :current-page.sync="CurrentPage"
      :page-size="RowsPerPage"
      layout="prev, pager, next, jumper"
      :total="Total">
    </el-pagination>
    </div>
    
  </div>
</template>

<script>
import EnumTree from '../../components/EnumTree'
export default {
  name: 'mainTest',
  components: {
    EnumTree
  },
  mounted(){

  },
  data () {
    return {
      Total:0,
      NodeData:null,
      RowsPerPage:10,
      CurrentPage:1,
      QueryData:null,
      parentMsg: {
        enumTitle: 'PeopleManagement'
      },
      dialogFormVisible: false,
      tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          flag:true
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
    }
  },
  methods: {
    AddPeople(){
      if(this.NodeData==null){
        this.$notify.error({
          title: '选择组织',
          message: '新增人员前请选择一个组织！'
        });
      }else{
        //弹窗
      }
    },
    LoadTable(){
      this.$axios.get(this.$idmConfig.UserListData + '?page='+this.CurrentPage+'&rows='+this.RowsPerPage+'&orgId='+this.NodeData.listenParentId).then(response => {
          
             console.log(response)
              this.Total=response.data.total;
              this.tableData=response.data.rows;
        }).catch(error => {
          console.log('error:' + error.toString())
        })
    },
    handleCurrentChange(page){
      console.log(page);
    },
    TreeNodeClick(data){
      console.log(data);
      this.NodeData=data;
      this.CurrentPage=1;
      this.LoadTable();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.m_container{
  display: inline;
  
}
.m_query{
  float: right;
  
}
.m_add_button{
  float: left;
}
.m_list{
  float:right;
  width: 79%;
  height: 100%;
  
}
.m_tree_list{
  float:left;
  width: 20%;
  
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/PeopleManagement/PeopleManagement.vue